import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';

const Footer = () => (
  <footer className="footer">
    <Row className="justify-content-between text-center fs-10 mt-4 mb-3">
      <Col sm="auto">
        <p className="mb-0 text-600">
          &copy; {new Date().getFullYear()} JMM Asesores. Todos los Derechos
          Reservados.
          <span className="d-none d-sm-inline-block">| Design by </span>
          <a href="https://theseven.digital/"> The 7</a>
        </p>
      </Col>
      <Col sm="auto">
        <p className="mb-0 text-600">v{version}</p>
      </Col>
    </Row>
  </footer>
);

export default Footer;
